import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  contentChild,
  effect,
  inject,
  input,
  output,
  signal,
  TemplateRef,
} from '@angular/core';
import { Shift } from '@wilson/interfaces';
import { ShiftDrawerModeService } from '../services/shift-drawer-mode.service';
import { SimplifiedShiftDrawerComponent } from '../simplified-shift-drawer/simplified-shift-drawer.component';

@Component({
  selector: 'wilson-simplified-or-detail-shift-wrapper',
  templateUrl: './simplified-or-detail-shift-wrapper.component.html',
  styleUrls: ['./simplified-or-detail-shift-wrapper.component.scss'],
  imports: [SimplifiedShiftDrawerComponent, NgTemplateOutlet],
})
export class SimplifiedOrDetailShiftWrapperComponent {
  private readonly shiftDrawerModeService = inject(ShiftDrawerModeService);

  readonly isDrawerVisible = input.required<boolean>();
  readonly selectedShiftId = input.required<string | null>();
  readonly closeDrawer = output<void>();
  readonly deletionConfirmed = output<Shift & { id: string }>();

  protected readonly drawerTemplate = contentChild(TemplateRef);
  protected readonly isSimplifiedShiftDrawer = signal<boolean | null>(null);

  constructor() {
    effect(() => {
      const isVisible = this.isDrawerVisible();

      if (isVisible) {
        this.shiftDrawerModeService
          .fetchIsSimplifiedShiftDrawer()
          .then((isSimplified) => {
            if (this.isDrawerVisible()) {
              this.isSimplifiedShiftDrawer.set(isSimplified);
            }
          });
      } else {
        this.isSimplifiedShiftDrawer.set(null);
      }
    });
  }
}
